import styled from 'styled-components';

export const Wrapper = styled.section`
    display: flex;
    flex: 1;
    min-height: 83vh;
`;

export const MainContent = styled.section`
    background-color: #ECEDF2;
    margin: 0;
    overflow-x: hidden;
    font-size: 10px !important;
    line-height: 1.5;
    width: 100%;
    min-height: calc(100vh - 64px);
`;
